<template>
    <div class="page-header-m ui-flex ui-flex-justify-center">
        <!-- 导航 -->
        <div class="page-nav ui-flex ui-flex-justify-center ui-flex-align-center">
            <div class="nav-logo"></div>
        </div>
    </div>
</template>

<script>
    import router from '@/router'
    export default {
       
        name: 'Header-m',
        
       
        
    }
</script>

<style lang="scss">
    @import './style.scss'
</style>